import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, { useContext, useState } from 'react';

import { JobAlertContext, JobDetailContext, JobShareContext } from '@/contexts';
import { useJobManagerUrlQuery } from '@/graphql/generated';
import { appendQueryParams } from '@/helpers/query-string';
import { unscrambleId } from '@/helpers/xing-one';
import { useBreakpoints, useLoginStates } from '@/hooks';
import { featuresShape } from '@/proptypes/job';

import ReportJobAdLightbox from './components/report-job-ad-lightbox';
import MeatballMenu from './meatball-menu-component';

export const addConditionalItem = (condition, item) => (condition ? [item] : []);

export const MeatballMenuContainer = ({ className, pdfUrl, features = {}, isOneClickExperiment }) => {
  const { isDesktop } = useBreakpoints();
  const { isLoggedOut } = useLoginStates();
  const [showReportJobAdLightbox, setShowReportJobAdLightbox] = useState(false);
  const [didReportJobAd, setDidReportJobAd] = useState(false);

  const { toggleAlertLightbox } = useContext(JobAlertContext);
  const { triggerShare } = useContext(JobShareContext);
  const { id: jobId } = useContext(JobDetailContext);
  const { data: xjmData } = useJobManagerUrlQuery({
    variables: { jobId: Number(unscrambleId(jobId)) },
    skip: isLoggedOut,
  });

  const onToggleReportJobAdLightbox = () => setShowReportJobAdLightbox(!showReportJobAdLightbox);
  const onReportJobAd = () => {
    onToggleReportJobAdLightbox();
    setDidReportJobAd(true);
  };
  const openAlertLightbox = () => {
    toggleAlertLightbox({ actionOrigin: 'jobs_menu' });
  };

  const jobUpsellUrl =
    features?.upsellUrl && appendQueryParams(features.upsellUrl, { sc_o: 'jobs_upsell_via_crawled_jobAd' });
  const showUpsellOption = jobUpsellUrl && isDesktop;
  const jobManagerUrl = R.path(['viewer', 'xjmJob', 'jobManagerUrl'], xjmData);
  const showManageOption = jobManagerUrl && isDesktop;

  const menuOptions = isLoggedOut
    ? [{ messageKey: 'JOBS_SHOW_PDF_MEATBALL_MENU_ACTION', href: pdfUrl }]
    : [
        { messageKey: 'JOBS_POSTING_ACTIONS_CREATE_ALERT', onClick: openAlertLightbox, fencedInSoftLogin: true },
        { messageKey: 'JOBS_DETAIL_SHARE', onClick: triggerShare, fencedInSoftLogin: true },
        ...addConditionalItem(pdfUrl, { messageKey: 'JOBS_SHOW_PDF_MEATBALL_MENU_ACTION', href: pdfUrl }),
        {
          messageKey: `JOB_POSTING_REPORT_${didReportJobAd ? 'SUCCESS' : 'LINK'}`,
          ...(!didReportJobAd && { onClick: onToggleReportJobAdLightbox }),
          fencedInSoftLogin: true,
        },
        ...addConditionalItem(showUpsellOption, {
          messageKey: 'JOB_POSTING_UPSELL_LINK',
          href: jobUpsellUrl,
          fencedInSoftLogin: true,
        }),
        ...addConditionalItem(showManageOption, {
          messageKey: 'JOB_ACTION_LIST_MANAGE',
          href: jobManagerUrl,
          fencedInSoftLogin: true,
        }),
      ];

  return (
    <>
      <MeatballMenu className={className} menuOptions={menuOptions} isOneClickExperiment={isOneClickExperiment} />
      <ReportJobAdLightbox
        isShown={showReportJobAdLightbox}
        onReport={onReportJobAd}
        onCancel={onToggleReportJobAdLightbox}
      />
    </>
  );
};

MeatballMenuContainer.propTypes = {
  className: PropTypes.string,
  pdfUrl: PropTypes.string,
  features: featuresShape,
  isOneClickExperiment: PropTypes.bool,
};

export default MeatballMenuContainer;
